"use strict";

class RentProductRequirmentUtil {

  constructor(rentProductRequirements, rentProductTypes) {
    this.rentProductRequirements = rentProductRequirements;
    this.rentProductTypes = rentProductTypes;
    
    // pouze ty requirements, pro ktere existuje rentProductType
    this.relevantRequirements = this.rentProductRequirements.filter(req => {
      return this.rentProductTypes.includes(req.rentProductType);
    });

    // inicializace
    this.nameDisplayed = false;
    this.nameRequired = false;
    this.sexDisplayed = false;
    this.sexRequired = false;
    this.ageDisplayed = false;
    this.ageRequired = false;
    this.weightDisplayed = false;
    this.weightRequired = false;
    this.heightDisplayed = false;
    this.heightRequired = false;
    this.shoeSizeDisplayed = false;
    this.shoeSizeRequired = false;
    this.rentAbilityLevelDisplayed = false;
    this.rentAbilityLevelRequired = false;

    for(let i=0; i < this.relevantRequirements.length; i++) {
      let r = this.relevantRequirements[i];

      this.nameDisplayed = this.nameDisplayed || r.nameDisplayed;
      this.nameRequired = this.nameRequired ||  r.nameRequired;
      this.sexDisplayed = this.sexDisplayed ||  r.sexDisplayed;
      this.sexRequired = this.sexRequired ||  r.sexRequired;
      this.ageDisplayed = this.ageDisplayed ||  r.ageDisplayed;
      this.ageRequired = this.ageRequired ||  r.ageRequired;
      this.weightDisplayed = this.weightDisplayed ||  r.weightDisplayed;
      this.weightRequired = this.weightRequired ||  r.weightRequired;
      this.heightDisplayed = this.heightDisplayed ||  r.heightDisplayed;
      this.heightRequired = this.heightRequired ||  r.heightRequired;
      this.shoeSizeDisplayed = this.shoeSizeDisplayed ||  r.shoeSizeDisplayed;
      this.shoeSizeRequired = this.shoeSizeRequired ||  r.shoeSizeRequired;
      this.rentAbilityLevelDisplayed = this.rentAbilityLevelDisplayed ||  r.rentAbilityLevelDisplayed;
      this.rentAbilityLevelRequired = this.rentAbilityLevelRequired ||  r.rentAbilityLevelRequired;
    }
  }

  isNameRequired() { return this.nameRequired; }
  isNameDisplayed() { return this.nameDisplayed; }

  isSexRequired() { return this.sexRequired; }
  isSexDisplayed() { return this.sexDisplayed; }

  isAgeRequired() { return this.ageRequired; }
  isAgeDisplayed() { return this.ageDisplayed; }

  isWeightRequired() { return this.weightRequired; }
  isWeightDisplayed() { return this.weightDisplayed; }

  isHeightRequired() { return this.heightRequired; }
  isHeightDisplayed() { return this.heightDisplayed; }

  isShoeSizeRequired() { return this.shoeSizeRequired; }
  isShoeSizeDisplayed() { return this.shoeSizeDisplayed; }

  isRentAbilityLevelRequired() { return this.rentAbilityLevelRequired; }
  isRentAbilityLevelDisplayed() { return this.rentAbilityLevelDisplayed; }



}

module.exports = RentProductRequirmentUtil;